import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "tw-flex tw-items-center tw-gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!
  const _component_InProgressIcon = _resolveComponent("InProgressIcon")!
  const _component_CheckmarkFilled = _resolveComponent("CheckmarkFilled")!
  const _component_CircleDashed = _resolveComponent("CircleDashed")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isEditing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.showLabel)
            ? (_openBlock(), _createBlock(_component_FilterableDropdown, {
                key: 0,
                autofocus: _ctx.autofocus,
                textLabel: "Trip Type",
                size: "sm",
                modelValue: _ctx.trip.tripType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trip.tripType) = $event)),
                options: _ctx.tripTypes,
                clearable: false,
                searchable: true,
                placeholder: "Trip Type",
                class: "uk-padding-remove-left uk-padding-remove-right uk-form-width-small"
              }, null, 8, ["autofocus", "modelValue", "options"]))
            : (_openBlock(), _createBlock(_component_FilterableDropdown, {
                key: 1,
                autofocus: _ctx.autofocus,
                size: "sm",
                modelValue: _ctx.trip.tripType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.trip.tripType) = $event)),
                options: _ctx.tripTypes,
                clearable: false,
                searchable: true,
                placeholder: "Trip Type",
                class: "uk-padding-remove-left uk-padding-remove-right uk-form-width-small"
              }, null, 8, ["autofocus", "modelValue", "options"]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.trip.status == 'In Progress')
            ? (_openBlock(), _createBlock(_component_InProgressIcon, {
                key: 0,
                title: "Trip is in Progress",
                class: "tw-h-4 tw-w-4 tw-text-emerald-600"
              }))
            : (_ctx.trip.status == 'Complete')
              ? (_openBlock(), _createBlock(_component_CheckmarkFilled, {
                  key: 1,
                  title: "Trip complete",
                  class: "tw-h-4 tw-w-4 tw-text-emerald-700"
                }))
              : (_openBlock(), _createBlock(_component_CircleDashed, {
                  key: 2,
                  title: "Trip not started",
                  class: "tw-h-4 tw-w-4 tw-text-slate-400"
                })),
          (_ctx.trip.tripType)
            ? (_openBlock(), _createElementBlock("span", {
                key: 3,
                class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-md tw-px-2 tw-py-0.5 tw-text-[11px] tw-font-semibold", 
          _ctx.gray
            ? 'tw-bg-slate-100 tw-text-slate-700'
            : _ctx.red
              ? 'tw-bg-rose-100 tw-text-rose-800'
              : _ctx.darkGreen
                ? 'tw-bg-emerald-100 tw-text-emerald-800'
                : _ctx.green
                  ? 'tw-bg-emerald-100 tw-text-emerald-800'
                  : 'tw-bg-slate-100 tw-text-slate-700'
        ])
              }, _toDisplayString(_ctx.trip.tripType), 3))
            : _createCommentVNode("", true)
        ]))
  ]))
}